import * as Yup from 'yup'

export const preferencesValidationSchema = Yup.object().shape({
  right_away_appointment_reminder: Yup.mixed()
    .transform((value) => Number(value))
    .oneOf([0, 1], 'Right away appointment reminder must be 0 or 1')
    .required('Right away appointment reminder is required'),

  first_appointment_reminder_before: Yup.number().when('right_away_appointment_reminder', {
    is: (value: number | boolean) => {
      const numValue = typeof value === 'boolean' ? (value ? 1 : 0) : Number(value)
      return numValue === 0
    },
    then: (schema) =>
      schema
        .integer('First appointment reminder must be a whole number')
        .min(1, 'First appointment reminder must be at least 1 day')
        .required(
          'First appointment reminder before days is required when right away reminder is disabled',
        ),
    otherwise: (schema) =>
      schema
        .notRequired()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)),
  }),

  confirm_appt_before: Yup.number()
    .min(0, 'Send cancellation policy reminder cannot be negative')
    .integer('Send cancellation policy reminder must be a whole number')
    .when(['right_away_appointment_reminder', 'first_appointment_reminder_before'], {
      is: (rightAway: number | boolean, firstReminder: number) => {
        const rightAwayNum =
          typeof rightAway === 'boolean' ? (rightAway ? 1 : 0) : Number(rightAway)
        return rightAwayNum === 0 && firstReminder > 0
      },
      then: (schema) =>
        schema.max(
          Yup.ref('first_appointment_reminder_before'),
          'Send cancellation policy reminder cannot be greater than first appointment reminder before days',
        ),
      otherwise: (schema) => schema,
    }),

  cancel_policy_charge_days: Yup.number()
    .min(0, 'Cancellation policy charge days cannot be negative')
    .integer('Cancellation policy charge days must be a whole number')
    .when('confirm_appt_before', {
      is: (confirmAppt: number) => typeof confirmAppt === 'number' && confirmAppt >= 0,
      then: (schema) =>
        schema.max(
          Yup.ref('confirm_appt_before'),
          'Cancellation policy charge days cannot be greater than send cancellation policy reminder',
        ),
      otherwise: (schema) => schema,
    }),
})
